import type { ReactNode } from 'react';
import * as styles from './Badge.module.css';

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function Badge(props: { children: ReactNode }) {
    return <span className={styles.badge}>{props.children}</span>;
}
